import { Stack, SxProps, Typography, useMediaQuery, useTheme } from '@mui/material';

/**
 * This component is part of the VR app V2 redesign
 */

interface IListItemCell {
  children: React.ReactNode;
  first?: boolean;
  subHeader?: boolean;
  colSpan?: number;
  sx?: SxProps;
}

/**
 * This component should be used as a child of ListItemLayout.
 * @param colSpan decides how many grid columns this cell will span
 */
const ListItemCell = ({ children, first, subHeader, colSpan = 2, sx }: IListItemCell) => {
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  const fontVariant = isSmDown ? 'textBase500' : 'textLg500';

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: first ? 'left' : 'center',
        ...(first && { gridColumn: `span ${colSpan}`, alignItems: 'start' }),
        ...sx,
      }}
    >
      {typeof children === 'string' || typeof children === 'number' ? (
        <Typography variant={fontVariant} color="dsBase.v200">
          {children}
        </Typography>
      ) : (
        children
      )}
    </Stack>
  );
};

export default ListItemCell;
